function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "0BCFA45F-E14D-4DF4-8AAC-46D930653D26");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Kronos_Style-guide_3",
  transform: "translate(-670.000000, -244.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-22",
  transform: "translate(100.000000, 100.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-21",
  transform: "translate(0.000000, 144.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-17",
  transform: "translate(120.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "attacks",
  transform: "translate(450.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 0,
  y: 0,
  width: 50,
  height: 50
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.5004447,4 C26.4057359,4 28.0966387,4.99096639 29.0250792,6.64833179 L47.3310903,39.289798 C48.2405125,40.9109086 48.2214941,42.8358694 47.280951,44.4397157 C46.338679,46.0435621 44.6667946,47 42.8064557,47 L6.1944336,47 C4.33409473,47 2.66221027,46.0435621 1.71993826,44.4397157 C0.779395192,42.8358694 0.758647918,40.912635 1.66807008,39.2915245 L19.9758101,6.64833179 C20.9042506,4.99096639 22.5951534,4 24.5004447,4 Z M24.5004447,7.45284458 C24.2164375,7.45284458 23.5378326,7.52803986 23.0845401,8.18655001 L22.9910805,8.33677279 L4.68506944,40.978239 C4.2493767,41.7568555 4.55367004,42.4370659 4.70408778,42.6943028 C4.85450551,42.9498133 5.30230083,43.5471554 6.1944336,43.5471554 L42.8064557,43.5471554 C43.7003174,43.5471554 44.1463838,42.9498133 44.2968015,42.6943028 C44.4472193,42.4370659 44.7515126,41.7568555 44.3140909,40.9765126 L26.0098088,8.33677279 C25.5620135,7.5391657 24.804738,7.45284458 24.5004447,7.45284458 Z M24.5004447,34.915044 C25.4565482,34.915044 26.2293841,35.6884811 26.2293841,36.6414663 L26.2293841,38.3678885 C26.2293841,39.3208736 25.4565482,40.0943108 24.5004447,40.0943108 C23.5443411,40.0943108 22.7715052,39.3208736 22.7715052,38.3678885 L22.7715052,36.6414663 C22.7715052,35.6884811 23.5443411,34.915044 24.5004447,34.915044 Z M24.5004447,15.9243988 C25.4565482,15.9243988 26.2293841,16.6978359 26.2293841,17.6508211 L26.2293841,31.4621994 C26.2293841,32.4151845 25.4565482,33.1886217 24.5004447,33.1886217 C23.5443411,33.1886217 22.7715052,32.4151845 22.7715052,31.4621994 L22.7715052,17.6508211 C22.7715052,16.6978359 23.5443411,15.9243988 24.5004447,15.9243988 Z",
  id: "Combined-Shape",
  fill: "currentColor",
  fillRule: "nonzero"
})))))));

var SvgIconWarningKronos = function SvgIconWarningKronos(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconWarningKronos, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/IconWarningKronos.ccb8257c.svg";
export { ForwardRef as ReactComponent };